import {
	FluxStandardAction,
	FluxStandardFailureAction,
} from '../../fluxStandardAction'
import { Psd2ConsentDto, BankError } from '#modules/Bank/Bank.types'

const PSD2_CONSENT_CLEAR_ERRORS_ACTION =
	'transactionClientApp/psd2Consent/clearErrors'
export type Psd2ConsentClearErrorsAction = {
	type: typeof PSD2_CONSENT_CLEAR_ERRORS_ACTION
}

const CREATE_PSD2_CONSENT_ACTION = 'transactionClientApp/psd2Consent/create'
export type CreatePsd2ConsentAction = FluxStandardAction<
	typeof CREATE_PSD2_CONSENT_ACTION,
	null
>

const CREATE_PSD2_CONSENT_SUCCEEDED_ACTION =
	'transactionClientApp/psd2Consent/createSucceeded'
export type CreatePsd2ConsentSucceededAction = FluxStandardAction<
	typeof CREATE_PSD2_CONSENT_SUCCEEDED_ACTION,
	string
>

const SET_PSD2_CONSENT_GIVEN_ACTION =
	'transactionClientApp/psd2Consent/setPsd2ConsentGiven'
export type SetPsd2ConsentGivenAction = FluxStandardAction<
	typeof SET_PSD2_CONSENT_GIVEN_ACTION,
	Psd2ConsentDto
>

const CREATE_PSD2_CONSENT_FAILED_ACTION =
	'transactionClientApp/psd2Consent/createFailed'
export type CreatePsd2ConsentFailedAction = FluxStandardFailureAction<
	typeof CREATE_PSD2_CONSENT_FAILED_ACTION
>

export type Psd2ConsentActions =
	| Psd2ConsentClearErrorsAction
	| CreatePsd2ConsentAction
	| CreatePsd2ConsentSucceededAction
	| CreatePsd2ConsentFailedAction
	| SetPsd2ConsentGivenAction

export function clearErrors(): Psd2ConsentClearErrorsAction {
	return {
		type: PSD2_CONSENT_CLEAR_ERRORS_ACTION,
	}
}

export function createPsd2Consent(): CreatePsd2ConsentAction {
	return {
		type: CREATE_PSD2_CONSENT_ACTION,
		payload: null,
	}
}

export function createPsd2ConsentSucceeded(
	token: string,
): CreatePsd2ConsentSucceededAction {
	return {
		type: CREATE_PSD2_CONSENT_SUCCEEDED_ACTION,
		payload: token,
	}
}

export function setPsd2ConsentGiven(
	psd2Consent: Psd2ConsentDto,
): SetPsd2ConsentGivenAction {
	return {
		type: SET_PSD2_CONSENT_GIVEN_ACTION,
		payload: psd2Consent,
	}
}

export function createPsd2ConsentFailed(
	createPsd2ConsentError: BankError,
): CreatePsd2ConsentFailedAction {
	return {
		type: CREATE_PSD2_CONSENT_FAILED_ACTION,
		payload: createPsd2ConsentError,
		error: true,
	}
}
